import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToolbarService } from '@progress/kendo-angular-scheduler';

@Component({
    selector: 'app-calendar-header',
    templateUrl: './calendar-header.component.html',
    styleUrls: ['./calendar-header.component.scss']
})
export class CalendarHeaderComponent {
    @Input() public selectedDate: Date;
    @Input() public selectedViewIndex = 2;

    @Output() public viewChange = new EventEmitter<number>();
    @Output() public dateChange = new EventEmitter<Date>();

    public calendarViews = [
        { text: "Timeline Day", value: 0 },
        { text: "Multi-week", value: 1 },
        { text: "Month", value: 2 },
        { text: "Timeline Week", value: 3 }
    ];

    constructor(public toolbarService: ToolbarService) { }

    public navigate(action: string): void {
        try {
            this.toolbarService.navigate({ type: action as any });
        } catch (e) {
            console.error('Navigation error:', e);
        }
    }

    public onCalendarViewChanges(event: any): void {
        this.viewChange.emit(event);
    }

    public onDateChange(event: Date): void {
        this.dateChange.emit(event);
    }
}
